export default function SizeSectionList({ catalogSizes, rowCount, renderRow }) {
  if (!rowCount) return null

  const groups = []
  for (let i = 0; i < rowCount; i++) {
    const name = String(catalogSizes?.[i]?.name || '').trim()
    const last = groups[groups.length - 1]
    if (last && last.name === name) last.end = i
    else groups.push({ name, start: i, end: i })
  }

  const hasNamed = groups.some((group) => group.name)

  return (
    <>
      {groups.map((group) => (
        <div
          key={`${group.start}-${group.end}-${group.name}`}
          className={
            hasNamed && group.name
              ? 'mb-2 space-y-1 rounded-md border-2 border-sky-400 bg-sky-50/50 p-2'
              : 'space-y-1'
          }
        >
          {hasNamed && group.name ? (
            <div className="px-1 pb-0.5 text-xs font-semibold uppercase tracking-wide text-sky-800">
              {group.name}
            </div>
          ) : null}
          {Array.from({ length: group.end - group.start + 1 }, (_, offset) =>
            renderRow(group.start + offset)
          )}
        </div>
      ))}
    </>
  )
}
